<template>
  <v-card class="my-5">
    <v-card-title> Invalid Duplicates </v-card-title>
    <v-card-subtitle>
      <p>product id: {{ current_conflict_product_id }}</p>
      <p>product brand: {{ current_product_info_object.product_brand.name }}</p>
      <p>product title: {{ current_product_info_object.product_name }}</p>
    </v-card-subtitle>
    <v-card-text v-for="domain in conflict_domains" :key="domain.domain_id">
      <div v-for="url in domain.domain_urls" :key="url.url_id">
        Duplicated Url: {{ decodeURI(url.url) }}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" large @click="removeConflict">
        <v-icon>delete</v-icon>remove
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="warning" large @click="resolveConflict">
        <!-- :to="{ name: 'conflict-table', params: {id: current_conflict_product_id} }" -->
        <v-icon>construction</v-icon>RESOLVE
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
export default {
    name: "N_ConflictCard",
    props: {
        current_conflict_product_id: {
            type: Number,
            default: null,
        },
        conflict_index: {
            type: Number,
        },
        for_create_new_product: {
          type: Boolean,
          default: false,
          required: false,
        }
    },
    computed: {
        conflict_domains() {
            return this.$store.state.productionModule.invalid_domains_urls.filter(
                domain => domain.product_id == this.current_conflict_product_id
            )
        },
        current_product_info_object() {
            return this.$store.state.productionModule.fetched_products_info.find(product => this.current_conflict_product_id == product.product_id);
        },
        // is_for_new_product() {
        //     return this.$store.state.productionModule.selected_product.id != this.current_conflict_product_id
        // }
    },
    data: () => ({
        empty_productInfo: {

        }
    }),
    methods: {
        removeConflict () {
            this.$store.commit("productionModule/RESET_PRODUCT_CONFLICT", this.current_conflict_product_id )
        },
        resolveConflict () {
          ////////// remake payload for conflictResolve
          const data = {
              task: "conflictResolve",
              // payload: this.$store.state.productionModule.conflict_temporary_urls,
              payload: {
                  invalid: Object.assign(this.$store.state.productionModule.conflict_temporary_urls.invalid, {hasInvalid: true}),
                  product_conflict: this.current_product_info_object,
                  product_pending: //this.$store.state.productionModule.selected_product.specs.product_info,
                    (this.for_create_new_product)
                      ? this.$store.state.productionModule.conflict_temporary_urls.valid.product_info
                      : this.$store.state.productionModule.selected_product.specs.product_info,
                  valid: this.$store.state.productionModule.conflict_temporary_urls.valid,
              }
          }
          this.$store.dispatch("productionModule/general_api", data).then(res => {
              console.log("conflictResolve response #357: ", res.data);
              this.$store.commit("productionModule/SET_PRODUCTION_STATE", {key: 'conflict_temporary_data', value: res.data.payload} );
              // this.$router.push({ name: 'conflict-table' });
              (this.for_create_new_product)
              ? this.$router.push({ name: 'conflict-new-product', params: {id: this.current_conflict_product_id, conflict_index: this.conflict_index} })
              : this.$router.push({ name: 'conflict-table', params: {id: this.current_conflict_product_id, conflict_index: this.conflict_index} });
          }).catch(err => {
              console.log('conflictResolve error: ', err);
              alert('conflictResolve error');
          })
        },
    },
    mounted() {
        console.log("resolve conflict on ", this.current_conflict_product_id);
  },
}
</script>


// WEBPACK FOOTER //
// src/components/production/N_ConflictCard.vue